import React, {useEffect, useRef, useState} from 'react';
import {Col, Form, Row} from 'react-bootstrap';

import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'js-cookie';
import {boldTextStyles, mediumTextStyles, regularErrorStyle, regularTextStyles} from "../Style";
import NavigateCarInsurance from "./NavigateCarInsurance";
import PostalAddress from "./PostalAddress";
import Switch from "react-switch";
import TooltipTFAF from "./common/TooltipTFAF";
import {useSearchParams} from "react-router-dom";
import moment from "moment";
import SaveEmailQuote from "./SaveEmailQuote";
import DatePicker from "react-datepicker";
import {FaCalendarAlt} from "react-icons/fa";
import handleCreditCardPayment from "./CreditCardPayment";
import {useCookies} from "react-cookie";
import {useGoogleReCaptcha} from "react-google-recaptcha-v3";

const PolicyHolder = (props) => {
  const [showNoAddressBlock, setShowNoAddressBlock] = useState(false);
  const [uniqueAddressFound, setUniqueAddressFound] = useState(false);
  const [errors, setErrors] = useState({});
  const [postalAddressList, setPostalAddressList] = useState({});
  const [addressSearchComplete, setAddressSearchComplete] = useState(false);
  //const [switchEnabled, setSwitchEnabled] = useState(false);
  //const [addressSwitchEnabled, setAddressSwitchEnabled] = useState(false);
  const [switchVehicleAddressEnabled, setSwitchVehicleAddressEnabled] = useState(false);
  const titleList = ["Mr", "Ms", "Mrs"];
  const mobileCodeNZ = ["021", "022", "027", "028", "029", "020"];
  const [showEmailPopup, setShowEmailPopup] = useState(false);
  let url = process.env.REACT_APP_MODE !== null && process.env.REACT_APP_MODE !== undefined && process.env.REACT_APP_MODE.includes('dev') ? 'http://localhost:8080/edge' : '/edge';
  const [searchParams] = useSearchParams();
  const [cookie, setCookie] = useCookies(['quote-id']);
  const datePickerRef = useRef(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const {executeRecaptcha} = useGoogleReCaptcha();
  const [verificationFailedStep, setVerificationFailedStep] = useState('');
  const [addressParams, setAddressParams] = useState(null);
  const baseUrl = window.location.origin;
  const eventName = window.location.href.includes('car')
    ? 'carAutosureEvent'
    : window.location.href.includes('quashed')
      ? 'carQuashedEvent'
      : window.location.href.includes('better')
        ? 'carBetterEvent'
        : window.location.href.includes('simplify')
          ? 'carSimplifyEvent'
          : '';

  useEffect((e) => {
    if (verificationFailedStep === 'callAddressSearch') {
      callAddressSearch(addressParams.addressLine1, addressParams.addressLine2, addressParams.suburb, addressParams.postCode, addressParams.nonUniqueAddress);
    } else if (verificationFailedStep === 'saveAndContinue') {
      saveAndContinue();
    }
  }, [props.inputValues.isRecaptchaV2Verified]);

  const handleIconClick = () => {
    // Trigger the DatePicker to open when the icon is clicked
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true); // Open the calendar
    }
  };

  useEffect(() => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': `${eventName}`,
        'category': 'Page View',
        'virtualUrl': `${baseUrl}/vehicle/step4`,
        'pageTitle': 'Policyholder',
      });
    window.scrollTo(0, 0)
    // Track the 'page loaded' event

    if (props.inputValues.policyHolderList.policyHolder1.firstName === '') {
      handleSwitchChange(true);
    }
  }, [])

  const steps = [{name: 'Step 1', status: 'complete', desc: 'Car'}, {
    name: 'Step 2',
    status: 'complete',
    desc: 'Driver'
  }, {name: 'Step 3', status: 'complete', desc: 'Quote'}, {
    name: 'Step 4',
    status: 'current',
    desc: 'Policyholder'
  }, {name: 'Step 5', status: 'upcoming', desc: 'Payment'},];

  const handleAddPolicyHolder = () => {
    if (props.inputValues.policyHolderLength < 5) {
      props.handleChangeValue('policyHolderLength', props.inputValues.policyHolderLength + 1);
    }
  };

  const postalAddress = (e) => {
    if (postalAddressList.suggestedAddresses.length > 1) {
      postalAddressList.suggestedAddresses.map(address => {
        if (address.addressId === e.target.value) {
          setPostalAddressList({});
          setPostalAddress(address);
        }
      })
    }
  }


  const handleRemovePolicyHolders = (index) => {
    if (props.inputValues.policyHolderLength > 1) {
      props.setPolicyHolderJson(`policyHolder${props.inputValues.policyHolderLength}.firstName`, '');
      props.setPolicyHolderJson(`policyHolder${props.inputValues.policyHolderLength}.lastName`, '');
      props.setPolicyHolderJson(`policyHolder${props.inputValues.policyHolderLength}.dateOfBirth`, '');
      props.setPolicyHolderJson(`policyHolder${props.inputValues.policyHolderLength}.title`, '');
      props.setPolicyHolderJson(`policyHolder${props.inputValues.policyHolderLength}.mobile`, '');
      props.setPolicyHolderJson(`policyHolder${props.inputValues.policyHolderLength}.email`, '');
      props.handleChangeValue('policyHolderLength', props.inputValues.policyHolderLength - 1);
    }
  };

  const calculateAge = (dateEntered) => {
    // Parse dateEntered using moment to ensure proper date handling
    let bday = moment(dateEntered, 'DD/MM/YYYY');
    if (!bday.isValid()) {
      return NaN; // Return NaN if the date is invalid
    }

    let today = moment();
    let age = today.diff(bday, 'years');  // Calculate age in years

    return age;
  }
  const handleSwitchChange = (isChecked) => {
    // setSwitchEnabled(isChecked);
    props.handleChangeValue('mainDriverDetailsSwitchEnabled', isChecked);

    if (isChecked) {
      props.setPolicyHolderJson("policyHolder1.firstName", props.inputValues.driverList.driver1.firstName);
      props.setPolicyHolderJson("policyHolder1.lastName", props.inputValues.driverList.driver1.lastName);
      props.setPolicyHolderJson("policyHolder1.dateOfBirth", props.inputValues.driverList.driver1.dateOfBirth);
    } else {
      props.setPolicyHolderJson("policyHolder1.firstName", '');
      props.setPolicyHolderJson("policyHolder1.lastName", '');
      props.setPolicyHolderJson("policyHolder1.dateOfBirth", '');
    }
  };
  const handleAddressSwitchChange = (isChecked) => {
    // setAddressSwitchEnabled(isChecked);
    props.handleChangeValue('addressSwitchEnabled', isChecked);
    setAddressSearchComplete(false);
    setPostalAddressList({});
    props.handleChangeValue('postalUniqueAddressFound', false);
    if (isChecked) {
      props.handleChangeValue('postalUniqueAddressFound', true);
      props.updatePostalAddress("postalAddress.fullAddress", props.inputValues.full_address);
      props.updatePostalAddress("postalAddress.addressId", props.inputValues.riskAddressId);
      props.updatePostalAddress("postalAddress.postcode", props.inputValues.riskPostcode);
      props.updatePostalAddress("postalAddress.signature", props.inputValues.riskSignature);
      props.updatePostalAddress("postalAddress.suburb", props.inputValues.riskSuburb);
      props.updatePostalAddress("postalAddress.buildingName", props.inputValues.riskBuildingName);
      props.updatePostalAddress("postalAddress.levelNumber", props.inputValues.riskLevelNumber);
      props.updatePostalAddress("postalAddress.levelType", props.inputValues.riskLevelType);
      props.updatePostalAddress("postalAddress.streetName", props.inputValues.riskStreetName);
      props.updatePostalAddress("postalAddress.streetNumber", props.inputValues.riskStreetNumber);
      props.updatePostalAddress("postalAddress.streetSuffixCode", props.inputValues.riskStreetSuffixCode);
      props.updatePostalAddress("postalAddress.streetType", props.inputValues.riskStreetType);
      props.updatePostalAddress("postalAddress.unitNumber", props.inputValues.riskUnitNumber);
      props.updatePostalAddress("postalAddress.unitType", props.inputValues.riskUnitType);
      props.updatePostalAddress("postalAddress.addressLine1", props.inputValues.riskAddressLine1);
      props.updatePostalAddress("postalAddress.addressLine2", props.inputValues.riskAddressLine2);

    } else {
      clearPostalAddress();
    }
  };

  const clearPostalAddress = () => {
    props.updatePostalAddress("postalAddress.fullAddress", '');
    props.updatePostalAddress("postalAddress.addressId", '');
    props.updatePostalAddress("postalAddress.postcode", '');
    props.updatePostalAddress("postalAddress.signature", '');
    props.updatePostalAddress("postalAddress.suburb", '');
    props.updatePostalAddress("postalAddress.buildingName", '');
    props.updatePostalAddress("postalAddress.levelNumber", '');
    props.updatePostalAddress("postalAddress.levelType", '');
    props.updatePostalAddress("postalAddress.streetName", '');
    props.updatePostalAddress("postalAddress.streetNumber", '');
    props.updatePostalAddress("postalAddress.streetSuffixCode", '');
    props.updatePostalAddress("postalAddress.streetType", '');
    props.updatePostalAddress("postalAddress.unitNumber", '');
    props.updatePostalAddress("postalAddress.postalUnitType", '');
    props.updatePostalAddress("postalAddress.addressLine1", '');
    props.updatePostalAddress("postalAddress.addressLine2", '');
  }


  const callAddressSearch = async (addressLine1, addressLine2, suburb, postCode, nonUniqueAddress) => {
    setAddressParams({addressLine1, addressLine2, suburb, postCode, nonUniqueAddress});
    let jwt = Cookies.get('jwt-token');
    if (!executeRecaptcha) {
      console.log('reCAPTCHA is not ready');
      return;
    }
    let token = await executeRecaptcha('submit');
    if (props.inputValues.isRecaptchaV2Verified) {
      token = "AUTHENTICATED_V2"
    }

    fetch(url + '/vero/address/postal', {

      method: "POST",
      mode: "cors",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${jwt}`
      }),
      body: JSON.stringify(
          {
            "addressInFreeForm": {
              "addressLine1": addressLine1,
              "addressLine2": addressLine2
            },
            "postcode": postCode,
            "suburb": suburb,
            "recaptchaResponse": token
          })
    })
        .then((response) => {
          if (response.status === 428) {
            // Show fallback captcha for 428 status
            console.log('Primary reCAPTCHA failed for postal callAddressSearch, showing fallback captcha');
            //setIsSubmitting(false);
            props.handleChangeValue("showRecaptchaPopup", true);
            setVerificationFailedStep("callAddressSearch");
            return;
          }
          // response.json().then((json) => {
          //     setShowNoAddressBlock(false);
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.text(); // Try to get the response as text first
        })
        .then((text) => {
          const newErrors = {};
          setErrors(newErrors);
          if (text) {
            const json = JSON.parse(text); // Parse it only if there's valid text
            // console.log("response.json() address", json);
            if (nonUniqueAddress) {
              setPostalAddressList([]);
            }
            props.handleChangeValue('postalUniqueAddressFound', false);
            if (json.data.attributes.suggestedAddresses.length === 0) {
              setAddressSearchComplete(false);
              setPostalAddressList([]);
              setShowNoAddressBlock(true);

            } else if (json.data.attributes.status == 'SUGGESTED' && json.data.attributes.suggestedAddresses.length == 1) {
              setPostalAddress(json.data.attributes.suggestedAddresses[0]);
              setAddressSearchComplete(false);
              props.handleChangeValue('postalUniqueAddressFound', true);
            } else if (json.data.attributes.status == 'SUGGESTED' && json.data.attributes.suggestedAddresses.length != 1) {
              setPostalAddressList(json.data.attributes);
              setAddressSearchComplete(true);
            }
          } else {
            throw new Error("Empty response from the server");
          }
        })
        // .catch((err) => console.error("Caught error: ", err));
        .catch((err) => {
          console.error("Caught error: ", err);
          const newErrors = {};
          newErrors.address = "Address not found.";
          setErrors(newErrors);
          props.handleChangeValue('addressLine1', '');
          props.handleChangeValue('addressLine2', '');
          props.handleChangeValue('suburb', '');
          props.handleChangeValue('city', '');
          props.handleChangeValue('postcode', '');
        });
  }

  const setPostalAddress = (address) => {
    props.handleChangeValue('postalUniqueAddressFound', true);
    clearPostalAddress();

    props.updatePostalAddress("postalAddress.addressId", address.addressId);
    props.updatePostalAddress("postalAddress.postcode", address.postcode);
    props.updatePostalAddress("postalAddress.signature", address.signature);
    props.updatePostalAddress("postalAddress.suburb", address.suburb);
    if (address.addressInBrokenDownForm !== undefined) {
      props.updatePostalAddress("postalAddress.buildingName", address.addressInBrokenDownForm.buildingName);
      props.updatePostalAddress("postalAddress.levelNumber", address.addressInBrokenDownForm.levelNumber);
      props.updatePostalAddress("postalAddress.levelType", address.addressInBrokenDownForm.levelType);
      props.updatePostalAddress("postalAddress.streetName", address.addressInBrokenDownForm.streetName);
      props.updatePostalAddress("postalAddress.streetNumber", address.addressInBrokenDownForm.streetNumber);
      props.updatePostalAddress("postalAddress.streetSuffixCode", address.addressInBrokenDownForm.streetSuffixCode);
      props.updatePostalAddress("postalAddress.streetType", address.addressInBrokenDownForm.streetType);
      props.updatePostalAddress("postalAddress.unitNumber", address.addressInBrokenDownForm.unitNumber);
      props.updatePostalAddress("postalAddress.unitType", address.addressInBrokenDownForm.unitType);
    }
    props.updatePostalAddress("postalAddress.addressLine1", address.addressInFreeForm.addressLine1);
    props.updatePostalAddress("postalAddress.addressLine2", address.addressInFreeForm.addressLine2);
    let addLine2 = (address.addressInFreeForm.addressLine2 != undefined && address.addressInFreeForm.addressLine2 != '') ? ',' + address.addressInFreeForm.addressLine2 : '';

    props.updatePostalAddress("postalAddress.fullAddress", address.addressInFreeForm.addressLine1 + addLine2);
  }
  const handlePaymentMethodChange = (event) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': `${eventName}`,
        'category': 'Payment Method',
        'categoryDetails': event.target.value,
        'virtualUrl': `${baseUrl}/vehicle/step4`,
        'pageTitle': 'Policyholder',
      });
    const selectedValue = event.target.value;
    props.handleChangeValue('paymentMethod', selectedValue);
  };
  const handlePaymentStartDateChange = (date) => {
    props.handleChangeValue('paymentStartDate', date);
  };
  const handleDateChange = (e) => {
    let inputVal = e.target.value;
    // Check if the input length is 2 or 5 and the last character is not "/"
    if ((inputVal.length === 2 || inputVal.length === 5) && inputVal.charAt(inputVal.length - 1) !== '/') {
      // Automatically append "/"
      inputVal += '/';
      e.target.value = inputVal;
    }
    props.handleUpdatePolicyHolderJson(e);
    // Update the input value
    props.handleChange(e);
  };
  const findFormErrors = () => {
    const newErrors = {}
    const nameRegex = /^[A-Za-z\s\-]+$/; // Regex to allow alphabets, space, and hyphen only
    const policyHolderArray = Object.keys(props.inputValues.policyHolderList).map(key => props.inputValues.policyHolderList[key]);
    if (props.inputValues.applicantType === 'Business' && (!props.inputValues.businessName || props.inputValues.businessName === '')) {
      newErrors.businessName = "Please enter your business Name";
    }
    for (let index = 0; index < props.inputValues.policyHolderLength; index++) {
      const policyholder = policyHolderArray[index];
      if (!policyholder.title) {
        newErrors[`policyHolder${index + 1}.title`] = "Please select title";
      }
      if (!policyholder.firstName) {
        newErrors[`policyHolder${index + 1}.firstName`] = "Please enter your first name";
      } else if (!nameRegex.test(policyholder.firstName)) {
        newErrors[`policyHolder${index + 1}.firstName`] = "Only letters, -, ' and space are allowed.";
      }
      if (!policyholder.lastName) {
        newErrors[`policyHolder${index + 1}.lastName`] = "Please enter your last name";
      } else if (!nameRegex.test(policyholder.lastName)) {
        newErrors[`policyHolder${index + 1}.lastName`] = "Only letters, -, ' and space are allowed.";
      }
      if (!policyholder.dateOfBirth) {
        newErrors[`policyHolder${index + 1}.dateOfBirth`] = "Please enter date of birth";
      } else {
        let dob = policyholder.dateOfBirth;
        let isValid = moment(dob, 'DD/MM/YYYY', true);
        if (!isValid.isValid()) {
          newErrors[`policyHolder${index + 1}.dateOfBirth`] = 'Invalid date. Please enter date in format dd/mm/yyyy.'
        } else {
          let age = calculateAge(policyholder.dateOfBirth);
          if (age < 16) {
            newErrors[`policyHolder${index + 1}.dateOfBirth`] = 'Age should be more than 16 years old'
          }
        }

      }
      if (!policyholder.mobile) {
        newErrors[`policyHolder${index + 1}.phone`] = "Please enter your phone number";
      } else if (policyholder.mobile.length < 6 || policyholder.mobile.length > 8) {
        // Mobile number length validation (between 6 and 8 digits)
        newErrors[`policyHolder${index + 1}.phone`] = "Please enter a valid mobile number";
      }
      if (!policyholder.email) {
        newErrors[`policyHolder${index + 1}.email`] = "Please enter a valid email address";
      } else {
        const emailFormat = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!policyholder.email.match(emailFormat)) {
          newErrors[`policyHolder${index + 1}.email`] = "Please enter a valid email address";
        }
      }
    }
    if (!props.inputValues.postalAddress.fullAddress || props.inputValues.postalAddress.fullAddress === '') {
      newErrors.address = "Please enter address";
    } else if (!props.inputValues.postalUniqueAddressFound) {
      newErrors.address = "Address not found";
    }
    return newErrors;
  }
  const saveAndContinue = async (e) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }
    setErrors({});
    const newErrors = findFormErrors();

    if (Object.keys(newErrors).length > 0) {
      // Scroll to the first error
      setErrors(newErrors);
      const firstErrorKey = Object.keys(newErrors)[0];
      const firstRef = newErrors[firstErrorKey];
      const errorElement = document.getElementsByName(firstErrorKey)[0];
      if (errorElement) {
        errorElement.scrollIntoView({behavior: 'smooth', block: 'center'});
      }
    } else if (props.inputValues.paymentFrequency !== "ANNUAL" && (!props.inputValues.paymentMethod || props.inputValues.paymentMethod === '')) {
      setErrors({});
      newErrors.paymentMethod = "Please select payment method";
      setErrors(newErrors);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': `${eventName}`,
          'category': 'Submit',
          'status': 'Fail',
          'virtualUrl': `${baseUrl}/vehicle/step4`,
          'pageTitle': 'Policyholder',
        });
    } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': `${eventName}`,
          'category': 'Submit',
          'categoryDetails': props.inputValues.paymentMethod,
          'status': 'Success',
          'virtualUrl': `${baseUrl}/vehicle/step4`,
          'pageTitle': 'Policyholder',
        });
      setIsButtonDisabled(true);
      savePolicyholderData();
      if (props.inputValues.paymentFrequency === 'ANNUAL' || props.inputValues.paymentMethod === 'Credit_Card') {
        setCookie('quote-id', props.inputValues.quoteNumber, {
          path: '/',
          maxAge: 600
        });
        // console.log("props.inputValues.quoteNumber", props.inputValues.quoteNumber);
        let quoteId = Cookies.get('quote-id');
        if (!executeRecaptcha) {
          console.log('reCAPTCHA is not ready');
          return;
        }
        let token = await executeRecaptcha('submit');
        if (props.inputValues.isRecaptchaV2Verified) {
          token = "AUTHENTICATED_V2";
          setCookie('AUTHENTICATED_V2', true, {
            path: '/',
            maxAge: 600
          });
        }
        handleCreditCardPayment(props, token);
      } else {
        props.nextStep();
      }
    }
  };
  const saveAndEmailQuote = (e) => {
    e.preventDefault();
    setErrors({});
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      // Scroll to the first error
      const firstErrorKey = Object.keys(newErrors)[0];
      const errorElement = document.getElementsByName(firstErrorKey)[0];
      if (errorElement) {
        errorElement.scrollIntoView({behavior: 'smooth', block: 'center'});
      }
      setErrors(newErrors);
    } else {
      savePolicyholderData(e);
      setShowEmailPopup(true);
    }
  }
  const savePolicyholderData = async () => {
    let jwt = Cookies.get('jwt-token');
    if (!jwt) {
      window.location.href = `/error-occurred`;
    }
    const policyHolderArray = Object.keys(props.inputValues.policyHolderList).map(key => props.inputValues.policyHolderList[key]);

    // Creating addressInBrokenDownForm object
    const addressInBrokenDownForm = {
      buildingName: props.inputValues.postalAddress.buildingName,
      levelNumber: props.inputValues.postalAddress.levelNumber,
      levelType: props.inputValues.postalAddress.levelType,
      streetName: props.inputValues.postalAddress.streetName,
      streetNumber: props.inputValues.postalAddress.streetNumber,
      streetSuffixCode: props.inputValues.postalAddress.streetSuffixCode,
      streetType: props.inputValues.postalAddress.streetType,
      unitNumber: props.inputValues.postalAddress.unitNumber,
      unitType: props.inputValues.postalAddress.unitType,
    };
// Creating addressInFreeForm object
    const addressInFreeForm = {
      addressLine1: props.inputValues.postalAddress.addressLine1,
      addressLine2: props.inputValues.postalAddress.addressLine2,
    };

    // Creating addressDetails object
    const addressDetails = {
      addressId: props.inputValues.postalAddress.addressId,
      postcode: props.inputValues.postalAddress.postcode,
      suburb: props.inputValues.postalAddress.suburb,
      signature: props.inputValues.postalAddress.signature,
      addressInBrokenDownForm: addressInBrokenDownForm,
      addressInFreeForm: addressInFreeForm,
      type: "POSTAL"
    };

    const additionalPolicyHolderArray = [];

    const formattedPolicyHolderList = policyHolderArray.map(policyHolder => ({
      firstName: policyHolder.firstName,
      lastName: policyHolder.lastName,
      dateOfBirth: policyHolder.dateOfBirth,
      title: policyHolder.title,
      email: policyHolder.email,
      mobile: policyHolder.mobileCode.concat(policyHolder.mobile),
      businessName: props.inputValues.businessName
    }));
    if (!executeRecaptcha) {
      console.log('reCAPTCHA is not ready');
      return;
    }
    let token = await executeRecaptcha('submit');
    if (props.inputValues.isRecaptchaV2Verified) {
      token = "AUTHENTICATED_V2"
    }
    fetch(url + '/vero/quote/create', {

      method: "POST",
      mode: "cors",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${jwt}`
      }),
      body: JSON.stringify(
          {
            id: props.inputValues.id,
            policyHolderDetails: formattedPolicyHolderList,
            addressDetails: addressDetails,
            "recaptchaResponse": token
          }
          // {"attributes":{"coverages":[{"compensations":[{"appliedIndicator":true,"compensationSubType":"AgreedValue","compensationType":"SumInsured","value":15000},{"appliedIndicator":true,"compensationSubType":"MarketValue","compensationType":"SumInsured","value":15000},{"appliedIndicator":false,"compensationSubType":"WindscreenExcessWaiver","compensationType":"CoverType"},{"appliedIndicator":true,"code":"HIRE_CAR_NOT_TAKEN","compensationSubType":"HireCar","compensationType":"CoverType"},{"appliedIndicator":true,"code":"NOT_ELIGIBLE","compensationSubType":"LifetimeNewForOld","compensationType":"CoverType"},{"appliedIndicator":false,"compensationSubType":"RoadsideAssist","compensationType":"CoverType"}],"policyCoverType":"COMPREHENSIVE","risk":{"addressDetails":{"addressId":"lUehd0gPgdL7FOGHQupuXBROntGLNm6wj66a0SsavQaXsKAYqpnZV9askzSBR8TE","addressInBrokenDownForm":{"streetName":"MANUKAU","streetNumber":"100","streetType":"RD"},"addressInFreeForm":{"addressLine1":"100 Manukau Rd"},"postcode":"1023","signature":"4TTiwKhzTf8t/twBDXACcZ/MnbZ3SszWCAQgu27b6xg=","suburb":"EPSOM"},"vehicleRisk":{"accessoriesIndicator":false,"additionalDrivers":[],"damagedIndicator":false,"financeIndicator":false,"mainDriver":{"claimHistory":[],"dateOfBirth":"1990-11-11"},"modificationIndicator":false,"vehicleKey":"0ATnSOMvvQ/q8WHUdGGSmQ==","vehicleUsageType":"PRIVATE"}},"voluntaryExcess":300}],"quoteRequestDetails":{"frequency":"FORTNIGHTLY","policyExpiryDate":"2025-03-27","policyInceptionDate":"2024-03-27","previousInsurer":"NONE"}},"type":"string"}

      )
    })
        .then(response => {
          if (response.status === 428) {
            // Show fallback captcha for 428 status
            console.log('Primary reCAPTCHA failed for saveAndContinue, showing fallback captcha');
            //setIsSubmitting(false);
            props.handleChangeValue("showRecaptchaPopup", true);
            setVerificationFailedStep("saveAndContinue");
            return;
          }
          if (!response.ok) {
            window.location.href = `/error-occurred`;
          }
          console.log("create");
        })
        .catch(error => {
          console.log('Error:', error);
          window.location.href = `/error-occurred`;
        });
  }
  const handleApplicantTypeUpdate = (event) => {
    event.preventDefault();
    props.handleChangeValue('applicantType', event.target.name);
  }
  return (

      <>
        <br/><br/>
        <Row className="justify-content-center">
          <NavigateCarInsurance steps={steps}/>
        </Row>
        <div className="lg-car-padding sm-car-padding" style={{display: 'flex', justifyContent: "center"}}>
          <Form onSubmit={(e) => e.preventDefault()}>
            <div style={{paddingTop: "20px", paddingBottom: "10px"}}><span style={boldTextStyles}>Select whether you'd like your policy in a private or
                            business name</span> </div>
            <div style={{display: "flex", gap: "20px"}}>
              {['Private', 'Business'].map((applicantType) => (
                  <button
                      key={applicantType}
                      type="button"
                      onClick={handleApplicantTypeUpdate}
                      style={{
                        wordWrap: "break-word",
                        backgroundColor:
                            props.inputValues.applicantType === applicantType ? "#4B5563" : "white",
                        color: props.inputValues.applicantType === applicantType ? "white" : "black",
                        width: "100%",
                        maxWidth: "150px",
                        lineHeight: "30px",
                        borderRadius: 50,
                        top: "2px",
                        position: "relative",
                        overflow: "hidden",
                        justifyContent: "center",
                        alignItems: "center",
                        display: "inline-flex",
                        cursor: "pointer",
                        border: "1px solid #D1D5DB",
                      }}
                      name={applicantType}
                  >
                    {applicantType}
                  </button>
              ))}
            </div>

            {props.inputValues.applicantType === "Business" && (
                <div style={{display: "flex", flexDirection: "column", paddingTop: "50px"}}>
                  <div style={regularTextStyles}>Name of the company or trust</div>
                  <Form.Group as={Col} md="3">
                    <input
                        className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        placeholder="Enter your company name"
                        style={{
                          border: '1px #E5E7EB solid',
                          boxShadow: '0px 1px 2px rgba(60, 66, 80, 0.05)',
                          borderRadius: 6,
                          outline: 'none',
                          fontSize: '1rem', //16px
                          fontFamily: 'Lato',
                          fontWeight: '400',
                          lineHeight: 'inherit',
                          width: '100%',
                          maxWidth: '300px',
                          height: '40px',
                          marginRight: '10px',
                          background: 'transparent',
                        }}
                        defaultValue={(props.inputValues.businessName)}
                        name="businessName"
                        onChange={props.handleChange}
                        isInvalid={!!errors.businessName}
                    />
                    {errors.businessName && (
                        <div style={regularErrorStyle}>{errors.businessName}</div>
                    )}
                  </Form.Group>
                </div>
            )}
            <div style={{paddingTop: "50px", paddingBottom: "10px", display: "flex", gap: "20px"}}>
              <div style={boldTextStyles}>Use main driver details</div>
              <Switch onColor="#86d3ff"
                      onHandleColor="#0a3fc4"
                      handleDiameter={20}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={20}
                      width={48}
                      className="react-switch"
                      id="material-switch"
                      onChange={handleSwitchChange} // Call handleSwitchChange when the switch state changes
                      checked={props.inputValues.mainDriverDetailsSwitchEnabled} // Pass the switch state to the checked prop
              />
            </div>
            {/*starts here*/}
            {Array.from(Array(props.inputValues.policyHolderLength), (policyholder, index) => <div key={index}>
              {/*{policyHolders.map((policyholder, index) => (<div key={index}>*/}
              {index !== 0 && (
                  <div style={{paddingTop: "30px"}}><span style={boldTextStyles}>Additional Policyholder</span></div>
              )}
              <div style={{display: "flex", justifyContent: "space-between"}}
                   className="column-on-mobile">
                <Form.Group as={Col} md="3" controlId={`formTitle${index}`} className="form-group">
                  <Form.Label style={regularTextStyles}>Title</Form.Label>
                  <select
                      className="block w-full rounded-md py-1.5 pl-10 pr-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      style={{
                        border: '1px #E5E7EB solid',
                        boxShadow: '0px 1px 2px rgba(60, 66, 80, 0.05)',
                        borderRadius: 6,
                        width: '100%',
                        maxWidth: '300px',
                        outline: 'none',
                        lineHeight: 'inherit',
                        fontSize: '1rem', //16px
                        fontFamily: 'Lato',
                        fontWeight: '400',
                        wordWrap: 'break-word',
                        height: '40px',
                        marginRight: '10px',
                        background: 'transparent',
                      }}
                      // defaultValue={(props.inputValues.policyHolderList.policyHolder1.title)}
                      value={props.inputValues.policyHolderList[`policyHolder${index + 1}`].title}
                      name={`policyHolder${index + 1}.title`}
                      onChange={props.handleUpdatePolicyHolderJson}>
                    <option value="">Please select</option>
                    {titleList.map(title => (
                        <option key={title} value={title}>{title}</option>
                    ))}
                  </select>
                  {errors[`policyHolder${index + 1}.title`] && (
                    <div style={regularErrorStyle}>{errors[`policyHolder${index + 1}.title`]}</div>
                  )}
                </Form.Group><Col md="1"/>
                <Form.Group md="3" as={Col} controlId={`formFirstName${index}`} className="form-group">
                  <Form.Label style={regularTextStyles}>First Name </Form.Label>
                  <input
                      type="text"
                      className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      placeholder="Enter first name"
                      style={{
                        border: '1px #E5E7EB solid',
                        boxShadow: '0px 1px 2px rgba(60, 66, 80, 0.05)',
                        borderRadius: 6,
                        outline: 'none',
                        fontSize: '1rem', //16px
                        fontFamily: 'Lato',
                        fontWeight: '400',
                        lineHeight: 'inherit',
                        width: '100%',
                        maxWidth: '300px',
                        height: '40px',
                        marginRight: '10px',
                        background: 'transparent',
                      }}
                      value={props.inputValues.policyHolderList[`policyHolder${index + 1}`].firstName}
                      name={`policyHolder${index + 1}.firstName`}
                      onChange={props.handleUpdatePolicyHolderJson}
                  />
                  {errors[`policyHolder${index + 1}.firstName`] && (
                    <div style={regularErrorStyle}>{errors[`policyHolder${index + 1}.firstName`]}</div>
                  )}
                </Form.Group><Col md="1"/>
                <Form.Group as={Col} md="3" controlId={`formLastName${index}`} className="form-group">
                  <Form.Label className="label" style={regularTextStyles}>Last Name</Form.Label>
                  <input
                      type="text"
                      className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      placeholder="Enter last name"
                      style={{
                        border: '1px #E5E7EB solid',
                        boxShadow: '0px 1px 2px rgba(60, 66, 80, 0.05)',
                        borderRadius: 6,
                        outline: 'none',
                        fontSize: '1rem', //16px
                        fontFamily: 'Lato',
                        fontWeight: '400',
                        lineHeight: 'inherit',
                        width: '100%',
                        maxWidth: '300px',
                        height: '40px',
                        marginRight: '10px',
                        background: 'transparent',
                      }}
                      value={props.inputValues.policyHolderList[`policyHolder${index + 1}`].lastName}
                      name={`policyHolder${index + 1}.lastName`}
                      onChange={props.handleUpdatePolicyHolderJson}
                  />
                  {errors[`policyHolder${index + 1}.lastName`] && (
                    <div style={regularErrorStyle}>{errors[`policyHolder${index + 1}.lastName`]}</div>
                  )}
                </Form.Group><Col md="1"/>
              </div>

              {/*second row*/}
              <br/>
              <div style={{display: "flex", justifyContent: "space-between"}}
                   className="column-on-mobile">
                <Form.Group as={Col} md="3" controlId={`formDateOfBirth${index}`}
                            className="form-group">
                  <Form.Label style={regularTextStyles}>Date of birth</Form.Label>
                  <input
                      type="text"
                      className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      placeholder='dd/mm/yyyy'
                      style={{
                        border: '1px #E5E7EB solid',
                        boxShadow: '0px 1px 2px rgba(60, 66, 80, 0.05)',
                        borderRadius: 6,
                        outline: 'none',
                        fontSize: '1rem', //16px
                        fontFamily: 'Lato',
                        fontWeight: '400',
                        lineHeight: 'inherit',
                        width: '100%',
                        maxWidth: '300px',
                        height: '40px',
                        marginRight: '10px',
                        background: 'transparent',
                      }}
                      name={`policyHolder${index + 1}.dateOfBirth`}
                      value={props.inputValues.policyHolderList[`policyHolder${index + 1}`].dateOfBirth}
                      onChange={handleDateChange}
                  />
                  {errors[`policyHolder${index + 1}.dateOfBirth`] && (
                    <div style={regularErrorStyle}>{errors[`policyHolder${index + 1}.dateOfBirth`]}</div>
                  )}
                </Form.Group><Col md="1"/>
                <Form.Group as={Col} md="3" controlId={`formEmailAddress${index}`}
                            className="form-group">
                  <Form.Label style={regularTextStyles}>Email Address</Form.Label>
                  <input
                      className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      placeholder="Enter your email"
                      style={{
                        border: '1px #E5E7EB solid',
                        boxShadow: '0px 1px 2px rgba(60, 66, 80, 0.05)',
                        borderRadius: 6,
                        outline: 'none',
                        fontSize: '1rem', //16px
                        fontFamily: 'Lato',
                        fontWeight: '400',
                        lineHeight: 'inherit',
                        width: '100%',
                        maxWidth: '300px',
                        height: '40px',
                        marginRight: '10px',
                        background: 'transparent',
                      }}
                      type="text"
                      name={`policyHolder${index + 1}.email`}
                      value={props.inputValues.policyHolderList[`policyHolder${index + 1}`].email}
                      // defaultValue={props.inputValues.policyHolderList.policyHolder1.email}
                      // value={props.email}
                      onChange={props.handleUpdatePolicyHolderJson}
                  />
                  {errors[`policyHolder${index + 1}.email`] && (
                    <div style={regularErrorStyle}>{errors[`policyHolder${index + 1}.email`]}</div>
                  )}
                </Form.Group><Col md="1"/>
                <Form.Group as={Col} md="3" controlId={`formMobile${index}`} className="form-group">
                  <Form.Label style={regularTextStyles}>Mobile</Form.Label>
                  <div style={{display: "flex", gap: "10px"}}>
                    <select
                        className="block w-full rounded-md py-1.5 pl-10 pr-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        style={{
                          border: '1px #E5E7EB solid',
                          boxShadow: '0px 1px 2px rgba(60, 66, 80, 0.05)',
                          borderRadius: 6,
                          width: '30%',
                          maxWidth: '100px',
                          outline: 'none',
                          lineHeight: 'inherit',
                          fontSize: '1rem', //16px
                          fontFamily: 'Lato',
                          fontWeight: '400',
                          wordWrap: 'break-word',
                          height: '40px',
                          background: 'transparent',
                        }}
                        name={`policyHolder${index + 1}.mobileCode`}
                        value={props.inputValues.policyHolderList[`policyHolder${index + 1}`].mobileCode}
                        onChange={props.handleUpdatePolicyHolderJson}
                    >
                      {mobileCodeNZ.map(code => (
                          <option key={code} value={code}>{code}</option>
                      ))}
                    </select>
                    <input
                        className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        style={{
                          border: '1px #E5E7EB solid',
                          boxShadow: '0px 1px 2px rgba(60, 66, 80, 0.05)',
                          borderRadius: 6,
                          outline: 'none',
                          fontSize: '1rem', //16px
                          fontFamily: 'Lato',
                          fontWeight: '400',
                          lineHeight: 'inherit',
                          width: '70%',
                          maxWidth: '200px',
                          height: '40px',
                          paddingRight: "10px",
                          background: 'transparent',
                        }}
                        type="number"
                        name={`policyHolder${index + 1}.mobile`}
                        value={props.inputValues.policyHolderList[`policyHolder${index + 1}`].mobile}
                        onChange={props.handleUpdatePolicyHolderJson}
                    /></div>
                  {errors[`policyHolder${index + 1}.phone`] && (
                    <div style={regularErrorStyle}>{errors[`policyHolder${index + 1}.phone`]}</div>
                  )}
                </Form.Group><Col md="1"/>
              </div>
            </div>)}
            {props.inputValues.policyHolderLength > 1 && (
                <div style={{color: "red", paddingTop: "30px"}}>-&nbsp;&nbsp;
                  <a
                      onClick={() => handleRemovePolicyHolders(props.inputValues.policyHolderLength)}
                      style={{textDecoration: 'underline', cursor: 'pointer', color: "red"}}>
                    Remove Policyholder
                  </a>
                </div>
            )}
            {props.inputValues.policyHolderLength < 5 && (
                <div style={{color: '#1851A3', paddingTop: "30px"}}>
                  +&nbsp;&nbsp;
                  <a onClick={handleAddPolicyHolder}
                     style={{textDecoration: 'underline', cursor: 'pointer', color: '#1851A3'}}>
                    Add another policyholder
                  </a>
                  <TooltipTFAF
                      title="Additional policyholders will share full authority and responsibilities under this policy with you. This means they can make changes, lodge claims, receive refunds and cancel or take over the policy at any time.">
                    <i className="fa fa-info-circle" style={{color: '#1851A3'}}/>
                  </TooltipTFAF>
                </div>
            )}
            {/*ends here*/}
            <br/>

            <div style={{display: "flex", justifyContent: "space-between"}} className="column-on-mobile">

              <Col md="1"/>
              <Col md="1"/>
            </div>
            <br/>
            <div style={{paddingBottom: "40px"}}>
                    <span style={mediumTextStyles}>
                   Postal Address
                    </span>
              <div style={{paddingTop: "5px", paddingBottom: "10px", display: "flex", gap: "20px"}}>
                <div style={boldTextStyles}>Use vehicle address</div>
                <Switch onColor="#86d3ff"
                        onHandleColor="#0a3fc4"
                        handleDiameter={20}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        height={20}
                        width={48}
                        className="react-switch"
                        id="material-switch"
                        onChange={handleAddressSwitchChange} // Call handleSwitchChange when the switch state changes
                        checked={props.inputValues.addressSwitchEnabled} // Pass the switch state to the checked prop
                />
              </div>

              <div style={{display: "flex", flexDirection: "column", paddingTop: "10px"}} className="column-on-mobile">
                <div>
                  <PostalAddress
                      inputValues={props.inputValues}
                      errors={errors}
                      handleChange={props.handleChange}
                      handleChangeValue={props.handleChangeValue}
                      setErrors={setErrors}
                      callAddressSearch={callAddressSearch}
                      uniqueAddressFound={props.inputValues.postalUniqueAddressFound}
                      setUniqueAddressFound={setUniqueAddressFound}
                      fullAddress={props.inputValues.postalAddress.fullAddress}
                      fullAddressName="postalAddress.fullAddress"
                      updatePostalAddress={props.updatePostalAddress}
                      addressType="postal"
                  />
                </div>
                <div style={{paddingTop: "10px"}}>
                  {addressSearchComplete && postalAddressList.suggestedAddresses != undefined ? postalAddressList.suggestedAddresses.map((postalAd, idx) =>
                      <Form.Check
                          type="radio"
                          label={postalAd.addressInFreeForm.addressLine1 + ", " + postalAd.suburb + " " + postalAd.postcode}
                          style={regularTextStyles}
                          id={`suggestedAdd${idx}`}
                          name={`suggestedAdd${idx}`}
                          value={postalAd.addressId}
                          onChange={postalAddress}
                      />
                  ) : <></>
                  }
                </div>
                {errors.address && (
                    <div style={regularErrorStyle}>{errors.address}</div>
                )}
              </div>
            </div>
            <div style={{paddingBottom: "40px"}}><span style={regularTextStyles}><i>For your convenience, we will send this policy's documents and related communications to
                            you <b>only by email</b>, so that you receive them quickly.</i></span>
            </div>
            {props.inputValues.paymentFrequency !== "ANNUAL" && (
                <div>
                  <div>How would you like to pay?</div>
                  <div style={{
                    display: "flex",
                    gap: "50px",
                    paddingTop: "10px",
                    paddingBottom: "50px",
                    flexDirection: window.innerWidth <= 768 ? "column" : "row",
                  }}>
                    <div style={{display: "flex", flexDirection: "column"}}>
                      <div>Payment method</div>
                      <div>
                        <Form.Group controlId={`formPaymentMethod`} className="form-group">
                          <Form.Select
                              className="block w-full rounded-md py-1.5 pl-10 pr-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                              style={{
                                border: '1px #E5E7EB solid',
                                boxShadow: '0px 1px 2px rgba(60, 66, 80, 0.05)',
                                borderRadius: 6,
                                width: '100%',
                                maxWidth: '300px',
                                fontSize: '1rem', //16px
                                fontFamily: 'Lato',
                                fontWeight: '400',
                              }}
                              name="paymentMethod"
                              value={props.inputValues.paymentMethod}
                              onChange={handlePaymentMethodChange}
                          >
                            <option value="" disabled>Please select</option>
                            <option value="Credit_Card">Direct Debit - Credit Card</option>
                            <option value="BANK_TRANSFER">Direct Debit - Bank Transfer
                            </option>
                          </Form.Select>
                        </Form.Group>
                      </div>
                      {errors.paymentMethod && (
                          <div style={regularErrorStyle}>{errors.paymentMethod}</div>
                      )}
                    </div>

                    {props.inputValues.paymentMethod === "Credit_Card" && (
                        <div style={{display: "flex", flexDirection: "column"}}>
                          <div>Payment start date</div>
                          <div style={{
                            width: '300px',
                            maxWidth: '300px',
                            marginRight: '10px',
                            position: 'relative'
                          }}>
                            <DatePicker
                                ref={datePickerRef}
                                //selected={props.inputValues.paymentStartDate ? props.inputValues.paymentStartDate : props.inputValues.policyStartDate}
                                selected={props.inputValues.paymentStartDate || props.inputValues.policyStartDate || new Date()}
                                onChange={(date) => props.handleChangeValue('paymentStartDate', date)}
                                dateFormat="dd/MM/yyyy"
                                className="custom-datepicker"
                                placeholderText="DD/MM/YYYY"
                                // minDate={props.inputValues.policyStartDate ? props.inputValues.policyStartDate : null}
                                minDate={props.inputValues.policyStartDate || null}
                                maxDate={props.inputValues.policyStartDate ? new Date(props.inputValues.policyStartDate.getTime() + 14 * 24 * 60 * 60 * 1000) : null}
                            />
                            <FaCalendarAlt
                                onClick={handleIconClick}
                                style={{
                                  position: 'absolute',
                                  right: '20px',
                                  top: '50%',
                                  transform: 'translateY(-50%)',
                                  cursor: 'pointer'
                                }}/>
                          </div>
                        </div>)}
                  </div>
                </div>
            )}
            <SaveEmailQuote showEmailPopup={showEmailPopup} setShowEmailPopup={setShowEmailPopup}
                            inputValues={props.inputValues}/>
            <button
                className="btn rounded-md px-4 py-2.5 text-sm font-weight-bold text-gray-900 shadow-sm"
                onClick={saveAndEmailQuote}
                style={{
                  color: '#1851A3',
                  paddingLeft: 25,
                  paddingRight: 25,
                  paddingTop: 13,
                  paddingBottom: 13,
                  background: 'white',
                  border: '1px #1851A3 solid',
                  justifyContent: 'center',
                  alignItems: 'center',
                  display: 'inline-flex',
                  wordWrap: 'break-word',
                  boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                  borderRadius: 6,
                  width: "100%",
                  maxWidth: "200px"
                }}>
              Email my quote
            </button>
            <p
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: "center",
                  paddingTop: '20px'
                }}>
              <button
                  className="btn rounded-md px-4 py-2.5 text-sm font-weight-bold text-gray-900 shadow-sm"
                  onClick={() => props.prevStep()}
                  style={{
                    color: '#1851A3',
                    paddingLeft: 25,
                    paddingRight: 25,
                    paddingTop: 13,
                    paddingBottom: 13,
                    background: 'white',
                    border: '1px #1851A3 solid',
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'inline-flex',
                    wordWrap: 'break-word',
                    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                    borderRadius: 6,
                    width: "100%",
                    maxWidth: "200px"
                  }}>
                Back
              </button>
              <button className="float-end"
                      onClick={saveAndContinue}
                      style={{
                        color: 'white',
                        paddingLeft: 25,
                        paddingRight: 25,
                        paddingTop: 13,
                        paddingBottom: 13,
                        width: "100%",
                        maxWidth: "200px",
                        background: isButtonDisabled ? '#B0C4DE' : '#1851A3',
                        boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                        borderRadius: 6,
                        overflow: 'hidden',
                        border: '1px white solid',
                        justifyContent: 'center',
                        alignItems: 'center',
                        display: 'inline-flex',
                        cursor: isButtonDisabled ? 'not-allowed' : 'pointer',
                        opacity: isButtonDisabled ? 0.6 : 1,
                      }}
                      disabled={isButtonDisabled}
              >
                Next
              </button>
            </p>
            <br/><br/><br/><br/><br/><br/>
          </Form></div>
      </>
  );

}

export default PolicyHolder;
